<template>
  <cf-accordion-item
    :animated="animated"
    :item-id="1"
    :open="isOpen"
    aria-label="Accordion Group"
    @accordion-item-selected="toggleOpen"
  >
    <template #item-title>
      <slot name="title" />
    </template>

    <template #item-content>
      <slot name="content" />
    </template>
  </cf-accordion-item>
</template>


<script>
  import CfAccordionItem from '@/view/components/shared/cf-accordion-item/index.vue';


  export default {
    name: 'CfExpandableSection',

    components: {
      CfAccordionItem
    },

    props: {
      animated: {
        type: Boolean,
        default: true
      },

      autoExpand: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        isOpen: false
      };
    },

    created() {
      this.createdHandler();
    },

    methods: {
      createdHandler() {
        this.isOpen = this.autoExpand;
      },

      toggleOpen() {
        this.isOpen = !this.isOpen;
      }
    }
  };
</script>
